const centroFuncional = {
  TELMEX: 'TELMEX',
  CLARO_GERAL: 'CLARO_GERAL',
  CLARO_SPO: 'CLARO_SPO',
  CLARO_BHE: 'CLARO_BHE',
}

const centroFuncionalLabels = {
  [centroFuncional.TELMEX]: 'Telmex',
  [centroFuncional.CLARO_GERAL]: 'Claro Geral',
}

const centroFuncionalCores = {
  [centroFuncional.TELMEX]: '#1565C0',
  [centroFuncional.CLARO_GERAL]: '#C62828',
  semCf: '#9E9E9E',
}

const centroFuncionalOpcoes = [
  { value: '', text: 'Todos' },
  { value: centroFuncional.CLARO_GERAL, text: 'Claro Geral (BHE e SPO)' },
  { value: centroFuncional.CLARO_SPO, text: 'Claro SPO' },
  { value: centroFuncional.CLARO_BHE, text: 'Claro BHE' },
  { value: centroFuncional.TELMEX, text: 'Telmex' },
]

function equipeAreaTecnica(areaTecnica) {
  const partes = String(areaTecnica || '')
    .split('/')
    .map(parte => parte.trim())
    .filter(Boolean)

  return (partes[1] || '').toUpperCase()
}

function labelCentroFuncional(valor, areaTecnica) {
  if (!valor) return ''

  if (valor === centroFuncional.TELMEX) return 'Telmex'

  if (valor === centroFuncional.CLARO_GERAL) {
    const equipe = equipeAreaTecnica(areaTecnica)
    if (equipe === 'BHE') return 'Claro BHE'
    if (equipe === 'SPO') return 'Claro SPO'
    return 'Geral'
  }

  return ''
}

function corCentroFuncional(valor) {
  return centroFuncionalCores[valor] || null
}

function calcularSemCf({ total = 0, telmex = 0, claro_geral = 0 } = {}) {
  return Math.max(Number(total) - Number(telmex) - Number(claro_geral), 0)
}

export {
  centroFuncional,
  centroFuncionalLabels,
  centroFuncionalCores,
  centroFuncionalOpcoes,
  labelCentroFuncional,
  equipeAreaTecnica,
  corCentroFuncional,
  calcularSemCf,
}
